<template>
    <div>
        <modal class="new-modal-small" :name="modal_name" transition="nice-modal-fade" :delay="100" height="auto" width="620" :min-width="200" :max-width="620" :pivot-y="0.5" :adaptive="true" :scrollable="true" :click-to-close="false">
            <div class="add-investment-header d-flex align-items-center justify-content-between">
                <span class="fs-18 fw-600 text-white">{{edit_data ? 'Edit Investment' : 'Add Investment'}}</span>
                <span class="pointer" :class="{'pointer-events-none': submitting}" @click="hideModal">
                    <i class="icon icon-close text-white fs-20"></i>
                </span>
            </div>
            <div class="add-investment-body">
                <div class="row">
                    <div class="col-md-6 col-sm-12 mt-3">
                        <span class="input-label">Investment Date<span class="pl-1 text-danger">*</span></span>
                        <div class="d-flex align-items-center mt-2">
                            <date-picker class="profile-date-picker calendar-edit-per input-field pt-0 pb-0 pr-0"
                                v-model="investment.investment_date" value-type="format"
                                v-validate="'required'" name="investment_date"
                                :not-before="today"
                                :clearable="false" :editable="false" style="padding-left: 0px !important;"
                                lang="en" type="date" format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                            </date-picker>
                        </div>
                        <span class="invalid-feedback-form text-danger" v-show="errors.has('investment_date')">
                            {{errors.first('investment_date')}}
                        </span>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-3">
                        <span class="input-label">Shares Purchased<span class="pl-1 text-danger">*</span></span>
                        <div class="d-flex align-items-center mt-2">
                            <input type="text" maxlength="20" class="input-field" v-validate="{required: true, regex: /^[1-9][\d,]*$/}"
                                v-model="investment.shares_purchased" placeholder="Enter No. of Shares"
                                @input="investment.shares_purchased = formatInputNumber(investment.shares_purchased, false)"
                                name="shares_purchased" />
                        </div>
                        <span class="invalid-feedback-form text-danger" v-show="errors.has('shares_purchased')">
                            {{errors.first('shares_purchased')}}
                        </span>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-5">
                        <span class="input-label">{{currency_symbol}} Invested<span class="pl-1 text-danger">*</span></span>
                        <div class="d-flex align-items-center mt-2">
                            <input type="text" maxlength="20" class="input-field" v-validate="{required: true, regex: /^[\d,]+(\.\d{1,2})?$/}"
                                v-model="investment.amount_invested" placeholder="0.00"
                                @input="investment.amount_invested = formatInputNumber(investment.amount_invested, true)"
                                name="amount_invested" />
                        </div>
                        <span class="invalid-feedback-form text-danger" v-show="errors.has('amount_invested')">
                            {{errors.first('amount_invested')}}
                        </span>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-5">
                        <span class="input-label">Reference / Transaction ID</span>
                        <div class="d-flex align-items-center mt-2">
                            <input type="text" maxlength="50" class="input-field"
                                v-model="investment.reference_id" placeholder="Enter Reference ID"
                                name="reference_id" />
                        </div>
                    </div>
                    <div class="col-12 mt-5">
                        <span class="input-label">Notes <span class="text-secondary fw-400">(Optional)</span></span>
                        <div class="d-flex align-items-center mt-2">
                            <textarea rows="4" maxlength="500" class="input-field notes-field"
                                v-model="investment.notes" placeholder="Add any notes or remarks..."
                                name="notes"></textarea>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-center mt-6">
                    <button class="btn btn-outline-secondary" :disabled="submitting" @click="hideModal" style="width: 120px;border-radius: 5px;">Cancel</button>
                    <button class="btn btn-new-primary ml-5 position-relative" :disabled="submitting" @click="submit" style="width: 120px;border-radius: 5px;">
                        <span :class="{'v-hidden': submitting}">{{edit_data ? 'Update' : 'Submit'}}</span>
                        <hollow-dots-spinner v-if="submitting" style="position: absolute;width: 100% !important;margin: 0;top: 50%;left: 0;transform: translateY(-50%);display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#fff'" />
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import moment from 'moment';
    import stakeholder from "../mixins/stakeholder.js"
    import { HollowDotsSpinner } from "epic-spinners";
    export default {
        mixins: [stakeholder],
        // The parent closes the popup after handling addInvestment; submitting shows the button loader meanwhile.
        props: ['modal_name', 'edit_data', 'submitting'],
        components: {
            HollowDotsSpinner
        },
        data() {
            return {
                investment: this.emptyInvestment(),
                today: moment().startOf('day').toDate(),
                warning_msg: '',
            }
        },
        methods: {
            emptyInvestment() {
                if (this.edit_data) {
                    return {
                        investment_date: moment(this.edit_data.investment_date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
                        shares_purchased: String(this.edit_data.shares_purchased),
                        amount_invested: String(Number(this.edit_data.amount_invested)),
                        reference_id: this.edit_data.reference_id || '',
                        notes: this.edit_data.notes || '',
                    }
                }
                return {
                    investment_date: moment().format('MM/DD/YYYY'),
                    shares_purchased: '',
                    amount_invested: '',
                    reference_id: '',
                    notes: '',
                }
            },
            hideModal() {
                this.$modal.hide(this.modal_name);
                this.$emit('hideAddInvestment');
            },
            submit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.$emit('addInvestment', {
                            investment_date: moment(this.investment.investment_date, 'MM/DD/YYYY').format('YYYY-MM-DD'),
                            shares_purchased: Number(this.investment.shares_purchased.replace(/,/g, '')),
                            amount_invested: Number(this.investment.amount_invested.replace(/,/g, '')).toFixed(2),
                            reference_id: this.investment.reference_id,
                            notes: this.investment.notes,
                        });
                    }
                })
            },
        },
        mounted() {
            this.investment.shares_purchased = this.formatInputNumber(this.investment.shares_purchased, false);
            this.investment.amount_invested = this.formatInputNumber(this.investment.amount_invested, true);
        },
        created() {
            const dict = {
                custom: {
                    investment_date: {
                        required: () => "Investment Date is required",
                    },
                    shares_purchased: {
                        required: () => "Shares Purchased is required",
                        regex: () => "Shares Purchased must be greater than 0",
                    },
                    amount_invested: {
                        required: () => "Amount Invested is required",
                        regex: () => "Enter a Valid Amount",
                    },
                }
            };
            this.$validator.localize("en", dict);
        },
    }
</script>

<style scoped>
    .pointer-events-none {
        pointer-events: none;
    }
    .add-investment-header {
        background-color: #1f3868;
        padding: 16px 24px;
    }
    .add-investment-body {
        background-color: #e8edf5;
        padding: 16px 24px 24px;
    }
    .notes-field {
        height: auto !important;
        resize: none;
        padding-top: 10px;
    }
    .btn-outline-secondary {
        color: #e82828;
        border: 1px solid #e82828 !important;
    }
    .btn-outline-secondary:hover {
        color: #fff;
        background-color: #e82828;
        border-color: #e82828 !important;
    }
</style>
